import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M14.401 8.398l1.599 -2.398h5l-4 6l4 6h-5l-8 -12h-5l4 6l-4 6h5l1.596 -2.393","key":"svg-0"}]]

/**
 * IconBrandXdeep
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItYnJhbmQteGRlZXAiCj4KICA8cGF0aCBzdHJva2U9Im5vbmUiIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiIC8+CiAgPHBhdGggZD0iTTE0LjQwMSA4LjM5OGwxLjU5OSAtMi4zOThoNWwtNCA2bDQgNmgtNWwtOCAtMTJoLTVsNCA2bC00IDZoNWwxLjU5NiAtMi4zOTMiIC8+Cjwvc3ZnPg==) - https://tabler.io/icons/icon/brand-xdeep
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconBrandXdeep = createReactComponent('outline', 'brand-xdeep', 'BrandXdeep', __iconNode);

export default IconBrandXdeep;